// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_address = /** @type {(inputs: {}) => string} */ () => {
	return `Address`
};

const el_address = /** @type {(inputs: {}) => string} */ () => {
	return `Διεύθυνση`
};

const ru_address = /** @type {(inputs: {}) => string} */ () => {
	return `Адрес`
};

const he_address = /** @type {(inputs: {}) => string} */ () => {
	return `כתובת`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const address = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.address(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("address", locale)
	if (locale === "en") return en_address(inputs)
	if (locale === "el") return el_address(inputs)
	if (locale === "ru") return ru_address(inputs)
	if (locale === "he") return he_address(inputs)
	return "address"
};